module.exports = __webpack_public_path__ + "static/media/artThreadLogo.fc4a78b9.png";